<template>
  <div class="placement-activity-results-wrapper">
    <div>
      <div v-if="countData && countData.givenRange" class="pa-result wide">
        <div class="title">Given Range</div>
        <tol-simple-table
          :table-data="countData.givenRange"
          :columns="placementActivityCountColumns"
        />
      </div>

      <div v-if="countData && countData.yearly" class="pa-result">
        <div class="title">Yearly</div>
        <tol-simple-table :table-data="countData.yearly" :columns="placementActivityCountColumns" />
      </div>

      <div v-if="countData && countData.quarterly" class="pa-result">
        <div class="title">Quarterly</div>
        <tol-simple-table
          :table-data="countData.quarterly"
          :columns="placementActivityCountColumns"
        />
      </div>
    </div>
    <div>
      <div v-if="countData && countData.monthly" class="pa-result">
        <div class="title">Monthly</div>
        <tol-simple-table
          :table-data="countData.monthly"
          :columns="placementActivityCountColumns"
        />
      </div>

      <div v-if="countData && countData.weekly" class="pa-result">
        <div class="title">Week Endings</div>
        <tol-simple-table :table-data="countData.weekly" :columns="placementActivityCountColumns" />
      </div>
    </div>
  </div>
</template>
<script>
import { PlacementActivityGetters } from '../placement-activity.keys';
import TolSimpleTable from '@/app/components/TolSimpleTable';
export default {
  name: 'PlacementActivityResults',
  components: {
    TolSimpleTable
  },
  data() {
    return {};
  },
  computed: {
    countData() {
      return this.$store.getters[PlacementActivityGetters.PlacementActivityCount];
    },

    placementActivityCountColumns() {
      return ['Date', 'Active', 'Perms', 'Starts', 'Stops'];
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/app/styles/colors.scss';

.placement-activity-results-wrapper {
  display: grid;
  grid-template-columns: 1fr;
}

.pa-result {
  .title {
    margin: 0 40px;
    font-size: 16pt;
    border-bottom: 1px solid $row-border;
  }
}

@media only screen and (min-width: 768px) {
  .placement-activity-results-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}
</style>
